import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./index.scss";
import { uncompressJSON } from './utils';
ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// const x = uncompressJSON("MTIwLDE1Niw3NywyMDQsMTc3LDE0LDIsMzMsMTYsMTMyLDIyNSw4NywxODUsNzYsNzcsMTYxLDE1NywyMjUsMjksMTA4LDE4MCw1MiwyMiwyMzUsMTc3LDgxLDExNCwxMDAsMzMsMTk5LDc0LDM2LDIyOCwyMjIsMjUzLDE5MiwxOTQsODgsMjA2LDI1NSwzNywyMTEsMjQwLDgsMTEzLDk0LDUwLDIzNiwxNzMsOTcsMjI1LDEwLDEzOSwyMjcsOTIsNzgsNSw2LDIwMiwzMSwyMzcsODMsNTcsMjM1LDg0LDEwNCwyNDUsMTY0LDYyLDIwMiwxNDgsNTMsMTc0LDExNywxMDQsNzcsMjIwLDI0NSw0NSw4OSwxMDcsOTYsMjE1LDEzOSwyMjcsMTY0LDQ3LDIxNiwxMzEsMTI5LDE1MSwyMjQsMTMzLDE3NSwzLDQ2LDM2LDc5LDMwLDIzOSwxMTksMywyMiwyNDUsOTAsMjU1LDEzOSwzNSwzNywyMTYsMTgyLDEwOSw2Myw2MSw4MywyNTAsMTM0LDI5LDExNSwyMjIsNTIsMTM4")
// console.log("x", x)